import { makeAutoObservable } from "mobx";

import { apiGetPatientsMinimal } from "../../api";
import { foldText } from "../../utils/text";
import { matchesTokens, searchTokens } from "../../utils/text-search";
import { PatientsItem } from "./patients";

export class PatientSearchModel {
  isOpen = false;
  loading = false;
  query = "";
  patients: PatientsItem[] = [];
  private loaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  async open() {
    this.isOpen = true;
    if (!this.loaded) {
      this.loading = true;
      const resp = await apiGetPatientsMinimal();
      this.patients = resp.data.patients as PatientsItem[];
      this.loaded = true;
      this.loading = false;
    }
  }

  close() {
    this.isOpen = false;
    this.query = "";
  }

  get filteredPatients(): PatientsItem[] {
    const tokens = searchTokens(this.query);
    if (tokens.length === 0) return this.patients;

    return this.foldedPatients
      .filter(({ haystacks }) => matchesTokens(haystacks, tokens))
      .map(({ patient }) => patient);
  }

  /**
   * Patients paired with the folded text they're matched against. A computed of
   * its own so the whole list is folded once per typing burst rather than on
   * every keystroke. The cache doesn't survive an empty query —
   * `filteredPatients` early-returns without reading this, so MobX drops it —
   * meaning the first keystroke after opening (or after `close` clears the
   * query) re-folds the list.
   */
  private get foldedPatients(): {
    patient: PatientsItem;
    haystacks: string[];
  }[] {
    return this.patients.map((patient) => ({
      patient,
      // Id first: a numeric token prefix-matches, so "12" finds patient 1234.
      // The name is folded so "Sperka" finds "Šperka".
      haystacks: [patient.patient_id.toString(), foldText(patient.full_name)],
    }));
  }
}
